import { setupAxios } from '../app/modules/auth'
import { api } from './APIMiddlewares'

/* ===============================
   GET DEPARTMENTS
=============================== */
export async function getDepartments() {
  const { token, tenantId } = setupAxios()
  return api.get('/departments', token, tenantId, false)
}

/* ===============================
   ADD DEPARTMENT
=============================== */
export async function addDepartment(payload: { name: string }) {
  const { token, tenantId } = setupAxios()

  return api.post(
    '/departments',
    token,
    tenantId,
    {
      body: JSON.stringify({
        name: payload.name,
      }),
    },
    false
  )
}

/* ===============================
   GET BY ID (OPTIONAL)
=============================== */
export async function getDepartmentById(id: string) {
  const { token, tenantId } = setupAxios()
  return api.get(`/departments/${id}`, token, tenantId, false)
}

/* ===============================
   UPDATE (OPTIONAL)
=============================== */
export async function updateDepartment(
  id: string,
  payload: { name: string }
) {
  const { token, tenantId } = setupAxios()
  return api.put(
    `/departments/${id}`,
    token,
    tenantId,
    {
      body: JSON.stringify(payload),
    },
    false
  )
}
